import { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerSurname, setCustomerFirstName, setCustomerTitle, setCustomerEmail, 
         setCustomerHomePhone, setCustomerMobilePhone, setCustomerPostCode, setMandatoryFieldsMissing, setPage,
         setInvalidEmail, setInvalidMobileNumber, setInvalidPostCode, setCustomerCountry,
         setCustomerCountryCode, setCustomerInternationalPhoneNumber, setInvalidInternationalPhoneNumber,
         } from '../../store/AppSlice';
import { pingServer } from '../../store/AppAPI';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';
import { COUNTRY_LIST } from './countries';


export const YourDetails = () => {

  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);
 
  useEffect(() => {
    dispatch(setMandatoryFieldsMissing(false));
    dispatch(setInvalidEmail(false));
    dispatch(setInvalidMobileNumber(false));
    dispatch(setInvalidPostCode(false));
    dispatch(setInvalidInternationalPhoneNumber(false));
    window.scrollTo(0,0);
    dispatch(pingServer());
  }, [dispatch]);

  const mandatoryFieldsCheck = () => {
    const { mandatoryFieldsMissing } = appstate;

    if (mandatoryFieldsMissing === true) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">* Please complete all mandatory fields
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }

  }

  const invalidEmailCheck = () => {
    const { invalidEmail } = appstate;

    if (invalidEmail === true) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">* Invalid email address
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  const invalidMobileNumberCheck = () => {
    const { invalidMobileNumber } = appstate;

    if (invalidMobileNumber === true) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">* Invalid mobile number
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  const invalidPostcodeCheck = () => {
    const { invalidPostCode } = appstate;

    if (invalidPostCode === true) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">* Invalid postcode
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  const invalidInternationalPhoneNumberCheck = () => {
    const { invalidInternationalPhoneNumber } = appstate;

    if (invalidInternationalPhoneNumber === true) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">* Invalid mobile number
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  const validateFirstName = () => {
    const { firstName} = appstate.bookingDetails.customerDetails;

    if (firstName && firstName.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const validateSurname = () => {
    const { surname } = appstate.bookingDetails.customerDetails;

    if (surname && surname.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const validateEmail = () => {
    const { email } = appstate.bookingDetails.contactDetails;

    var regexp = /\S+@\S+\.\S+/;

    // If the email is not present then do not set as invalid
    if (!email || email.length === 0) {
      setInvalidEmail(false);
      return true;
    }

    if (regexp.test(email)) {
      dispatch(setInvalidEmail(false));
      return true;
    } else {
      dispatch(setInvalidEmail(true));
      return false;
    }
  }

  const validateMobileNumber = () => {
    const { mobileNumber } = appstate.bookingDetails.contactDetails;

    var regexp = /^0([1-6][0-9]{8,10}|7[0-9]{9})$/;

    // If the mobile number is not present then do not set as invalid
    if (!mobileNumber || mobileNumber.length === 0) {
      dispatch(setInvalidMobileNumber(false));
      return true;
    }
    
    if (mobileNumber && mobileNumber.length > 0 && regexp.test(mobileNumber)) {
      dispatch(setInvalidMobileNumber(false));
      return true;
    } else {
      dispatch(setInvalidMobileNumber(true));
      return false;
    }
  }

  const validatePostCode = () => {
    const { postCode } = appstate.bookingDetails.contactDetails;

    var regexp = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/;

    if (!postCode || postCode.length === 0) {
      dispatch(setInvalidPostCode(false));
      return true;
    }

    if (regexp.test(postCode)) {
      dispatch(setInvalidPostCode(false));
      return true;
    } else {
      dispatch(setInvalidPostCode(true));
      return false;
    }
  }

  const validateInternationalPhoneNumber = () => {
    const { countryCode, internationalPhoneNumber } = appstate.bookingDetails.contactDetails;

    var regexp1 = /^\d{1,3}$/;
    var regexp2 = /^\d{6,15}$/;
    console.log("Regexp countryCode: " + countryCode + " is " + regexp1.test(countryCode));
    console.log("Regexp phone num: " + internationalPhoneNumber + " is " + regexp2.test(internationalPhoneNumber));

    // If the mobile number is not present then do not set as invalid
    if ((!countryCode || countryCode.length === 0) &&
        (!internationalPhoneNumber || internationalPhoneNumber.length === 0)) {
      dispatch(setInvalidInternationalPhoneNumber(false));
      return true;
    }
    
    if (countryCode && countryCode.length > 0 && regexp1.test(countryCode) &&
        internationalPhoneNumber && internationalPhoneNumber.length > 0 && regexp2.test(internationalPhoneNumber)) {
      dispatch(setInvalidInternationalPhoneNumber(false));
      return true;
    } else {
      dispatch(setInvalidInternationalPhoneNumber(true));
      return false;  
    }
  }

  const mandatoryEmail = () => {
    const { email } = appstate.bookingDetails.contactDetails;

    if (email && email.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const mandatoryMobileNumber = () => {
    const { mobileNumber } = appstate.bookingDetails.contactDetails;

    if (mobileNumber && mobileNumber.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const mandatoryInternationalPhoneNumber = () => {
    const { countryCode, internationalPhoneNumber } = appstate.bookingDetails.contactDetails;

    if (countryCode && countryCode.length > 0 &&
        internationalPhoneNumber && internationalPhoneNumber.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const mandatoryPostCode = () => {
    const { postCode } = appstate.bookingDetails.contactDetails;

    if (postCode && postCode.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const validateFields = () => {
    const { country } = appstate.bookingDetails.contactDetails;

    if (country === "United Kingdom") {
      validateEmail();
      validateMobileNumber();
      validatePostCode();
  
      if (validateFirstName() &&
          validateSurname() &&
          mandatoryEmail() &&
          mandatoryMobileNumber() &&
          mandatoryPostCode()
          ) {
            dispatch(setMandatoryFieldsMissing(false));
            if (validateEmail() &&
                validateMobileNumber() &&
                validatePostCode()) {
                  dispatch(setPage("REVIEW_BOOKING"));
                }            
      } else {
        dispatch(setMandatoryFieldsMissing(true));
      }
    } else {

      validateEmail();
      validateInternationalPhoneNumber();

      if (validateFirstName() &&
          validateSurname() &&
          mandatoryEmail() &&
          mandatoryInternationalPhoneNumber()
          ) {
            dispatch(setMandatoryFieldsMissing(false));
            if (validateEmail() &&
                validateInternationalPhoneNumber()) {
                  dispatch(setPage("REVIEW_BOOKING"));
                }            
      } else {
        dispatch(setMandatoryFieldsMissing(true));
      }

    }

  }

  const getCountries = COUNTRY_LIST.map((item) => (
      <option value={item.id} key={item.id}>
      {item.id}
      </option>
  ));

  const getPhoneAndLocationDetails = () => {
    const { bookingDetails } = appstate; 
    const { homeNumber, mobileNumber, postCode, country, countryCode, internationalPhoneNumber } = bookingDetails.contactDetails;
  
    if (country === "United Kingdom") {
      return (<Fragment>
                {invalidMobileNumberCheck()}
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="generalText">
                      <div className="generalTextBox">
                        <label htmlFor="mobile-phone" className="label-text">Mobile number:
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-8">
                    <div>
                      <input id="mobile-phone" type="tel" pattern="[0-9]*" noValidate className="input-text" value={mobileNumber} onChange={(e) => dispatch(setCustomerMobilePhone(e.target.value))}></input>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="generalText">
                      <div className="generalTextBox">
                        <label htmlFor="home-phone" className="label-text">Home number (optional):
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-8">
                    <div>
                      <input id="home-phone" type="tel" pattern="[0-9]*" noValidate className="input-text" value={homeNumber} onChange={(e) => dispatch(setCustomerHomePhone(e.target.value))}></input>
                    </div>
                  </div>
                </div>
                {invalidPostcodeCheck()}
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="generalText">
                      <div className="generalTextBox">
                        <label htmlFor="customer-postcode" className="label-text">Postcode:
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-8">
                    <div>
                      <input id="customer-postcode" className="input-text" value={postCode} onChange={(e) => dispatch(setCustomerPostCode(e.target.value))}></input>
                    </div>
                  </div>
                </div>
              </Fragment>
      );
    } else {
      return (<Fragment>
        {invalidInternationalPhoneNumberCheck()}
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="mobile-phone" className="label-text">Phone number:
                </label>
              </div>
            </div>
          </div>
          <div className="col-1 col-sm-1">
            <div className="generalText">
              <div className="generalTextBox">
                +
              </div>
            </div>
          </div>
          <div className="col-11 col-sm-7 plus-sign">
            <div>
              <input id="international-code" type="num" size="3" pattern="[0-9]*" maxLength="3" noValidate className="input-text" value={countryCode} onChange={(e) => dispatch(setCustomerCountryCode(e.target.value))} style={{marginRight:"0.5rem"}}></input>
              <input id="mobile-phone" type="tel" pattern="[0-9]*" noValidate maxLength="15" className="input-text" value={internationalPhoneNumber} onChange={(e) => dispatch(setCustomerInternationalPhoneNumber(e.target.value))}></input>
            </div>
          </div>
        </div>
        </Fragment>
      );
    }
  }

  const { bookingDetails } = appstate; 
  const { surname, firstName, title } = bookingDetails.customerDetails; 
  const { email, homeNumber, mobileNumber, postCode, country } = bookingDetails.contactDetails;

  return (
    <div className="row">
      <div className="col-12 col-lg-6 imagesBackgroundColour">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Your Details<span style={{"fontSize": "0.8rem"}}>&nbsp; &nbsp;&nbsp;(Step 2 of 4)</span></h4>
            </div>            
          </div>
        </div>          
        {mandatoryFieldsCheck()}
        <div className="row" style={{"marginTop": "1rem"}}>
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="customer-title" className="label-text">Title
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div>
              <select className="duration-select input-text" value={title} name="customer-title" id="customer-title"
                  onChange={(event) => {dispatch(setCustomerTitle(event.target.value))}}>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
              </select>
              </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="firstname" className="label-text">First Name
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div>
              <input id="firstname" className="input-text" value={firstName} onChange={(e) => dispatch(setCustomerFirstName(e.target.value))}></input>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="surname" className="label-text">Surname
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div>
              <input id="surname" className="input-text" value={surname} onChange={(e) => dispatch(setCustomerSurname(e.target.value))}></input>
            </div>
          </div>
        </div>
        {invalidEmailCheck()}
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="email-address" className="label-text">Email Address
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div>
              <input id="email-address" type="email" className="input-text" value={email} onChange={(e) => dispatch(setCustomerEmail(e.target.value))}></input>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="customer-country" className="label-text">Country
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-8">
            <div>
              <select className="duration-select input-text" value={country} name="customer-country" id="customer-country"
                  onChange={(event) => {dispatch(setCustomerCountry(event.target.value))}}>
                  {getCountries}
              </select>
              </div>
          </div>
        </div>
        {getPhoneAndLocationDetails()}
        <div className="row">
        <div className="col-6 back-btn-col">
            <p className="back-button">
              <span className="navigate-span">
                <a className="your-details-button" onClick={() => { dispatch(setPage("YOUR_PARTY"))}}>Back</a>
              </span>
            </p>
          </div>          
          <div className="col-6 selected-week-book-btn-col">
            <p className="book-selected-date-button">
              <span className="navigate-span">
                <a className="your-details-button" onClick={() => { validateFields()}}>Continue</a>
              </span>
            </p>
          </div>          
        </div>
      </div>
      <div className="col-12 col-lg-6 imagesBackgroundColour">
        <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
      </div>
    </div>
  );
}

